var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReload = function SvgReload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.2.2.1-Queue-/-Register-patient---with-lab-number",
    transform: "translate(-684.000000, -462.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.Health-screening/Register/Patient-info",
    transform: "translate(368.000000, 144.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(296.000000, 298.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3742233,3.87498837 C13.5734687,3.87226162 15.6783395,4.76354828 17.2065195,6.34246177 L17.2636064,6.40202453 L17.613,6.80798213 L19.0582032,5.36328122 C19.4519532,4.96874996 20.125,5.24843747 20.125,5.80546872 L20.125,10.125 C20.125,10.470178 19.845178,10.75 19.5,10.75 L15.1804688,10.75 C14.6234375,10.75 14.3445313,10.0769531 14.7382813,9.68320311 L16.727,7.69398213 L16.3370703,7.24171292 L16.3083342,7.21180823 C15.0289592,5.88995986 13.271654,5.13796969 11.431361,5.12515536 L11.375,5.12499416 C7.5795542,5.12499416 4.49999996,8.20455169 4.49999996,12 C4.49999996,15.7954471 7.57955295,18.875 11.3749578,18.875 C14.2598091,18.8748053 16.8346347,17.0750295 17.8292068,14.3736078 L17.8588603,14.2914715 C17.9740275,13.9660727 18.3311767,13.7956463 18.6565755,13.9108134 C18.9819742,14.0259806 19.1524006,14.3831298 19.0372335,14.7085286 C17.8883122,17.9547459 14.8185792,20.1247676 11.375,20.125 C6.88919701,20.125 3.24999996,16.485803 3.24999996,12 C3.24999996,7.51419605 6.88919796,3.87498837 11.3742233,3.87498837 Z",
    id: "Combined-Shape",
    fill: "currentColor",
    mask: "url(#mask-2)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reload.0ccc7e6f.svg";
export { ForwardRef as ReactComponent };